import React from 'react';
import Header from '../HeaderSection/HeaderMobiCloud';
import FooterSection from '../FooterSection/FooterMobiCloud';

const PrivacyPolicy = () => {
    return (
        <div>
            <Header imageData={"/img/logo-white.png"} />
            
            <section className="section pt-5 mt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <div className="text-center mb-5">
                                <h1 className="mb-4">Privacy Policy</h1>
                                <p className="text-muted">Last updated: December 2024</p>
                            </div>
                            
                            <div className="content">
                                <h2>1. Introduction</h2>
                                <p>MobiCloud ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
                                
                                <h2>2. Information We Collect</h2>
                                <h3>2.1 Personal Information</h3>
                                <p>We may collect personal information that you voluntarily provide to us when you:</p>
                                <ul>
                                    <li>Contact us through our website</li>
                                    <li>Subscribe to our newsletter</li>
                                    <li>Request a consultation or quote</li>
                                    <li>Apply for employment</li>
                                    <li>Use our services</li>
                                </ul>
                                <p>This information may include:</p>
                                <ul>
                                    <li>Name and contact information (email, phone, address)</li>
                                    <li>Company information</li>
                                    <li>Project requirements and specifications</li>
                                    <li>Communication preferences</li>
                                </ul>
                                
                                <h3>2.2 Automatically Collected Information</h3>
                                <p>When you visit our website, we automatically collect certain information about your device, including:</p>
                                <ul>
                                    <li>IP address</li>
                                    <li>Browser type and version</li>
                                    <li>Operating system</li>
                                    <li>Pages visited and time spent</li>
                                    <li>Referring website</li>
                                </ul>
                                
                                <h2>3. How We Use Your Information</h2>
                                <p>We use the information we collect to:</p>
                                <ul>
                                    <li>Provide and maintain our services</li>
                                    <li>Respond to your inquiries and requests</li>
                                    <li>Send you marketing communications (with your consent)</li>
                                    <li>Improve our website and services</li>
                                    <li>Comply with legal obligations</li>
                                    <li>Protect against fraud and security threats</li>
                                </ul>
                                
                                <h2>4. Information Sharing and Disclosure</h2>
                                <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:</p>
                                <ul>
                                    <li>With service providers who assist us in operating our business</li>
                                    <li>To comply with legal requirements</li>
                                    <li>To protect our rights and safety</li>
                                    <li>In connection with a business transfer or merger</li>
                                </ul>
                                
                                <h2>5. Data Security</h2>
                                <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
                                
                                <h2>6. Cookies and Tracking Technologies</h2>
                                <p>We use cookies and similar tracking technologies to enhance your experience on our website. You can control cookie settings through your browser preferences.</p>
                                
                                <h2>7. Your Rights</h2>
                                <p>Depending on your location, you may have the following rights regarding your personal information:</p>
                                <ul>
                                    <li>Access and review your personal information</li>
                                    <li>Correct inaccurate information</li>
                                    <li>Request deletion of your information</li>
                                    <li>Object to processing of your information</li>
                                    <li>Data portability</li>
                                </ul>
                                
                                <h2>8. International Data Transfers</h2>
                                <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your information.</p>
                                
                                <h2>9. Children's Privacy</h2>
                                <p>Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.</p>
                                
                                <h2>10. Changes to This Policy</h2>
                                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.</p>
                                
                                <h2>11. Contact Us</h2>
                                <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
                                <div className="contact-info mt-3">
                                    <p><strong>Email:</strong> privacy@mobicloud.ai</p>
                                    <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                                    <p><strong>Address:</strong> 123 Tech Street, Silicon Valley, CA 94025</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <FooterSection />
        </div>
    );
};

export default PrivacyPolicy; 